export default "__VITE_ASSET__BTauT27Y__"